import { useCallback, useState } from 'react';
import { useUdsRouting } from '../../../../../providers/UdsRoutingProvider';
type StorageKey = string;

interface Options {
  useStorageKey?: StorageKey;
  useUrlParams?: boolean;
}

export function useSearchStringStorage(options: Options) {
  const [{ useStorageKey, useUrlParams }] = useState<Options>(options);
  const { getLocation, navigate } = useUdsRouting();
  const location = getLocation?.() ?? {};

  const getSearchString = useCallback(() => {
    const searchString = useUrlParams ? location.search : '';
    return useStorageKey && !searchString ? getFromLocalStorage(useStorageKey) : searchString;
  }, [location.search, useStorageKey, useUrlParams]);

  // do not use "?" at the start of a search string
  const setSearchString = useCallback(
    (value: string | null) => {
      if (!!useStorageKey) {
        saveInLocalStorage(useStorageKey, value);
      }
      if (!!useUrlParams) {
        navigate?.(`${location.pathname}${value ? `?${value}` : ''}`, { replace: true });
      }
    },
    [navigate, location.pathname, useStorageKey, useUrlParams]
  );

  return {
    setSearchString,
    getSearchString
  };
}

function saveInLocalStorage(key: string, value: string | null) {
  if (value === null) {
    return window.localStorage.removeItem(key);
  }
  return window.localStorage.setItem(key, value);
}

function getFromLocalStorage(key: string) {
  return window.localStorage.getItem(key);
}
